import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteQuickAlertsUrl } from "../../../../config";
import { Status } from "../../../../common/constants";
import { RootState } from "../../../../store";
import api from "../../../../api";

const initialState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

interface IDeleteQuickAlertResponse {
  message: string;
}

interface IDeleteQuickAlertPayload {
  alertId: string;
}

const DELETE_QUICK_ALERT: string = "deleteQuickAlert";

export const deleteQuickAlert = createAsyncThunk(
  DELETE_QUICK_ALERT,
  async (
    deleteQuickAlertPayload: IDeleteQuickAlertPayload,
    { rejectWithValue }
  ) => {
    const { alertId } = deleteQuickAlertPayload;
    try {
      const response = await api.delete<IDeleteQuickAlertResponse>(
        `${deleteQuickAlertsUrl}?alertId=${alertId}`
      );
      const deleteQuickAlertResponse: IDeleteQuickAlertResponse = response.data;
      return deleteQuickAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deleteQuickAlertSlice = createSlice({
  name: DELETE_QUICK_ALERT,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteQuickAlert.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deleteQuickAlert.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(deleteQuickAlert.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || "Error occurred while deleting";
      });
  },
});

export const selector = (state: RootState) => state.deleteQuickAlertsApi;

export const reducer = deleteQuickAlertSlice.reducer;
